module.exports = __webpack_public_path__ + "img/ApfelEssen.2c0518be.svg";